var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Cross } from '../../svgs';
var SHOW_TIME_SECS = 30;
var HIDE_TIME = 1;
export function Message(props) {
    var _a = useState(true), shown = _a[0], setShown = _a[1];
    var _b = useState(true), displayed = _b[0], setDisplayed = _b[1];
    var message = props.message;
    useEffect(function () {
        var timeout = setTimeout(function () {
            setShown(false);
        }, 1000 * SHOW_TIME_SECS);
        return function () {
            clearTimeout(timeout);
        };
    }, []);
    useEffect(function () {
        if (!shown) {
            var timeOut_1 = setTimeout(function () {
                setDisplayed(false);
            }, 1000 * HIDE_TIME);
            return function () { return clearTimeout(timeOut_1); };
        }
    }, [shown]);
    if (!displayed)
        return null;
    return (_jsxs(StyledMessage, __assign({ shown: shown, type: message.type }, { children: [_jsx(Cross, { className: 'message-close', onClick: function () { return setShown(false); } }, void 0), message.message] }), void 0));
}
var StyledMessage = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  transition: opacity ", "s;\n  box-sizing: border-box;\n  opacity: ", ";\n  padding: 15px;\n\n  min-width: 200px;\n  /* min-height: 50px; */\n  font-size: 1.6rem;\n  margin: 5px 20px;\n  border-radius: 4px;\n  ", "\n  position: relative;\n  .message-close {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    width: 10px;\n    height: 10px;\n    padding: 5px;\n    cursor: pointer;\n  }\n"], ["\n  transition: opacity ", "s;\n  box-sizing: border-box;\n  opacity: ", ";\n  padding: 15px;\n\n  min-width: 200px;\n  /* min-height: 50px; */\n  font-size: 1.6rem;\n  margin: 5px 20px;\n  border-radius: 4px;\n  ",
    "\n  position: relative;\n  .message-close {\n    position: absolute;\n    top: 5px;\n    right: 5px;\n    width: 10px;\n    height: 10px;\n    padding: 5px;\n    cursor: pointer;\n  }\n"])), HIDE_TIME, function (_a) {
    var shown = _a.shown;
    return (shown ? 1 : 0);
}, function (_a) {
    var type = _a.type;
    switch (type) {
        case 'notice':
            return "\n                background-color: green;\n                color:white;\n                ";
        case 'error':
            return "\n                background-color: red;\n                color:white;\n                ";
    }
});
var templateObject_1;
